import Vue from 'vue';
import apiKeysServices from '../api/ApiKeys';
import appServices from '../api/App';
import appLogsServices from '../api/AppLogs';
import appSystemServices from '../api/AppSystem';
import appSystemsServices from '../api/AppSystems';
import appSystemWebApisServices from '../api/AppSystemWebApis';
import authServices from '../api/Auth';
import callLogsServices from '../api/CallLogs';
import contactIdMappingsServices from '../api/ContactIdMappings';
import documentsServices from '../api/Documents';
import dynamicFormServices from '../api/DynamicForm';
import fieldMappingServices from '../api/FieldMapping';
import httpMethodLookupServices from '../api/HttpMethodLookup';
import integrationCallsServices from '../api/IntegrationCalls';
import integrationTasksServices from '../api/IntegrationTasks';
import locationsServices from '../api/Locations';
import meServices from '../api/Me';
import onlinePaymentTransactionServices from '../api/OnlinePaymentTransaction';
import processesServices from '../api/Processes';
import recurringMembershipPaymentsServices from '../api/RecurringMembershipPayments';
import sequencenumbersServices from '../api/Sequencenumbers';
import tenantsServices from '../api/Tenants';
import usersServices from '../api/Users';
import widgetAnimaturaServices from '../api/WidgetAnimatura';
import widgetAnimaturaTopicsServices from '../api/WidgetAnimaturaTopics';
import widgetMembershipsServices from '../api/WidgetMemberships';
import widgetMembershipTemplatesServices from '../api/WidgetMembershipTemplates';
import widgetNimSServices from '../api/WidgetNimS';
import widgetNimSCertificatsServices from '../api/WidgetNimSCertificats';
import widgetNimSGardenAdvicesServices from '../api/WidgetNimSGardenAdvices';
import widgetNimSGardenCertificationsServices from '../api/WidgetNimSGardenCertifications';
import widgetNimSGardenTypesServices from '../api/WidgetNimSGardenTypes';
import widgetNimSTopicsServices from '../api/WidgetNimSTopics';
import widgetOMServices from '../api/WidgetOM';

export default () => ({
  apiKeys: { ...apiKeysServices(Vue.$service) },
  app: { ...appServices(Vue.$service) },
  appLogs: { ...appLogsServices(Vue.$service) },
  appSystem: { ...appSystemServices(Vue.$service) },
  appSystems: { ...appSystemsServices(Vue.$service) },
  appSystemWebApis: { ...appSystemWebApisServices(Vue.$service) },
  auth: { ...authServices(Vue.$service) },
  callLogs: { ...callLogsServices(Vue.$service) },
  contactIdMappings: { ...contactIdMappingsServices(Vue.$service) },
  documents: { ...documentsServices(Vue.$service) },
  dynamicForm: { ...dynamicFormServices(Vue.$service) },
  fieldMapping: { ...fieldMappingServices(Vue.$service) },
  httpMethodLookup: { ...httpMethodLookupServices(Vue.$service) },
  integrationCalls: { ...integrationCallsServices(Vue.$service) },
  integrationTasks: { ...integrationTasksServices(Vue.$service) },
  locations: { ...locationsServices(Vue.$service) },
  me: { ...meServices(Vue.$service) },
  onlinePaymentTransaction: { ...onlinePaymentTransactionServices(Vue.$service) },
  processes: { ...processesServices(Vue.$service) },
  recurringMembershipPayments: { ...recurringMembershipPaymentsServices(Vue.$service) },
  sequencenumbers: { ...sequencenumbersServices(Vue.$service) },
  tenants: { ...tenantsServices(Vue.$service) },
  users: { ...usersServices(Vue.$service) },
  widgetAnimatura: { ...widgetAnimaturaServices(Vue.$service) },
  widgetAnimaturaTopics: { ...widgetAnimaturaTopicsServices(Vue.$service) },
  widgetMemberships: { ...widgetMembershipsServices(Vue.$service) },
  widgetMembershipTemplates: { ...widgetMembershipTemplatesServices(Vue.$service) },
  widgetNimS: { ...widgetNimSServices(Vue.$service) },
  widgetNimSCertificats: { ...widgetNimSCertificatsServices(Vue.$service) },
  widgetNimSGardenAdvices: { ...widgetNimSGardenAdvicesServices(Vue.$service) },
  widgetNimSGardenCertifications: { ...widgetNimSGardenCertificationsServices(Vue.$service) },
  widgetNimSGardenTypes: { ...widgetNimSGardenTypesServices(Vue.$service) },
  widgetNimSTopics: { ...widgetNimSTopicsServices(Vue.$service) },
  widgetOM: { ...widgetOMServices(Vue.$service) },
});
